
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import routeService from '@/services/route.service';
  import tokenService from '@/services/token.service';

  @Component({
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  })
  export default class ConfirmQualificationSurvey extends Vue {
    created() {
      if (tokenService.hasToken(this) == null) {
        routeService.redirectToLogin(this, this.$router.currentRoute.path);
      }
    }

    linkSteam() {
      this.$router.push({
        name: 'SteamLink',
        query: {
          redirectUrl: this.$data.RCEnvironment.VUE_APP_FRONT_URL + "profile/me/rewards"
        }
      });
    }
  }
